/**
 * Created by psivanappans on 10/03/2022
 * File: ConnectedPlatforms
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo } from 'react'
import { Body } from '@panwds/react-ui'
import DividerLine from '../../../../../common/components/dividerLine/DividerLine'
import { CAN_BE_USED_ON } from '../../../../constants/LabelConstants'
import { APP_ID_CASB_NGFW, APP_ID_NG_CASB, CONNECTED_PLATFORMS } from '../../../../../common/constants/GlobalConstants'

const LineItem = ({ platform, tenantStatus, message }) => {
  return (
    <div className="tw-grid tw-grid-cols-3 tw-gap-4 tw-px-3">
      <div> {platform} </div>
      <div> {tenantStatus} </div>
      { message && <div>{ message }</div> }
    </div>
  )
}

const ConnectedPlatforms = (props) => {
  const { licenseContext, selectedTSGInstances } = props
  const connectedApps = CONNECTED_PLATFORMS[licenseContext]
  const platforms = useMemo(() => {
    const canBeUsedInstances = selectedTSGInstances?.filter(instance => connectedApps.has(instance.app_id))?.map((instance) => {
      return { ...connectedApps.get(instance.app_id) }
    })
    if (connectedApps && licenseContext === APP_ID_NG_CASB) { // add NGFW for CASB-x context
      canBeUsedInstances.push({ ...connectedApps.get(APP_ID_CASB_NGFW) })
    }

    return canBeUsedInstances.map((each, index) => {
      return <LineItem key={index} {...{ ...each }} />
    })
  }, [selectedTSGInstances, licenseContext, connectedApps])

  return (
    <div className="tw-p-3 tw-flex tw-flex-col tw-gap-3">
      <DividerLine />
      <Body size="lg" addClassName="tw-font-lato tw-italic tw-mb-2">{CAN_BE_USED_ON}</Body>
      {platforms}
    </div>
  )
}

ConnectedPlatforms.propTypes = {}
export default ConnectedPlatforms
